export const HIGHWAY_TYPE_LABELS = {
  motorway: 'Autopista',
  motorway_link: 'Acceso a autopista',
  trunk: 'Ruta principal',
  trunk_link: 'Acceso a ruta principal',
  primary: 'Avenida principal',
  primary_link: 'Acceso a avenida principal',
  secondary: 'Avenida secundaria',
  secondary_link: 'Acceso a avenida secundaria',
  tertiary: 'Calle colectora',
  tertiary_link: 'Acceso a calle colectora',
  residential: 'Calle residencial',
  living_street: 'Calle peatonal compartida',
  service: 'Calle de servicio',
  unclassified: 'Calle sin clasificar',
  track: 'Camino rural',
  path: 'Sendero',
  footway: 'Senda peatonal',
  cycleway: 'Ciclovia',
  steps: 'Escaleras',
  pedestrian: 'Zona peatonal',
};

export const STREET_POSITION_LABELS = {
  midblock: 'Entre medianeras',
  corner: 'Esquina',
  island: 'Exento',
};

export const getHighwayLabel = (type) => HIGHWAY_TYPE_LABELS[type] ?? type ?? '—';

export const getStreetPositionLabel = (position) =>
  STREET_POSITION_LABELS[position] ?? '—';

export const NEIGHBORHOOD_TYPE_LABELS = {
  barrio_cerrado: 'Barrio cerrado',
  barrio_popular: 'Barrio popular',
  barrio_residencial: 'Barrio residencial',
  barrio_industrial: 'Barrio industrial',
  barrio_rural: 'Área rural',
};

export const NEIGHBORHOOD_TYPE_EMPTY_LABEL = 'Sin asignar';

export const getNeighborhoodTypeLabel = (type) => {
  if (type == null || String(type).trim() === '') {
    return NEIGHBORHOOD_TYPE_EMPTY_LABEL;
  }

  const key = String(type).trim().toLowerCase();
  return NEIGHBORHOOD_TYPE_LABELS[key] ?? key;
};

export const LOT_SHAPE_LABELS = {
  circular: 'Circular',
  triangular: 'Triangular',
  cuadrado: 'Cuadrado',
  rectangular: 'Rectangular',
  rectangular_alargado: 'Rectangular alargado',
  lote_en_tira: 'Lote en tira',
  irregular_reentrada: 'Con reentradas',
  irregular_organica: 'Forma orgánica',
  poligonal: 'Poligonal',
  irregular: 'Irregular',
};

export const LOT_SHAPE_EMPTY_LABEL = 'Sin asignar';

export const getLotShapeLabel = (shape) => {
  if (shape == null || String(shape).trim() === '') {
    return LOT_SHAPE_EMPTY_LABEL;
  }

  const key = String(shape).trim().toLowerCase();
  return LOT_SHAPE_LABELS[key] ?? key;
};
